import React from "react";
import "../css/MainScreen.css";
import {
    Typography,
    AppBar,
    IconButton,
    Grid,
} from "@material-ui/core";
import BackIcon from "./svg/BackIcon";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";

type TopBarProps = {
    back?: boolean;
    path?: string;
    action?: Function;
}

export default function TopBar({ back, path, action }: TopBarProps): JSX.Element {
    const history = useHistory();

    const onClick = action || (() => history.goBack());

    const button = path ? (
        <Link to={path}>
            <IconButton color="secondary" edge="start" id={"BackButton"}>
                <BackIcon />
            </IconButton>
        </Link>
    ) : (
        <IconButton color="secondary" edge="start" id={"BackButton"} onClick={() => onClick()}>
            <BackIcon />
        </IconButton>
    );
    const backButton = back && button;

    return (
        <AppBar position="static" color="primary" id={"TopBar"}>
            <Grid container direction="row" justify="flex-start" alignItems="center">
                {backButton}
                <Typography variant="h4" id="AppName">
                    QUIZZERO
                </Typography>
                <span />
            </Grid>
        </AppBar>
    );
}
